import styled from 'styled-components'

export const FooterButtons = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 1.875rem;
  border-top: 1px solid var(--card-border);
`
